import { render } from "./SinglePageView.vue?vue&type=template&id=689611b5&scoped=true"
import script from "./SinglePageView.vue?vue&type=script&lang=js"
export * from "./SinglePageView.vue?vue&type=script&lang=js"

import "./SinglePageView.vue?vue&type=style&index=0&id=689611b5&scoped=true&lang=less"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-689611b5"]])

export default __exports__